import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Grid, Typography, TextField, Divider,
  Checkbox, FormControlLabel, FormGroup, Button, Stack, Snackbar, IconButton
} from "@mui/material";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import MuiAlert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from "dayjs";

import logo from '../img/logo-llantas.png';
import imgCamion from '../img/Camion2.jpg';
import imgBri from '../img/bridgestone.jpg';

const OrdenServicioCentroCamioneroModal = ({ open, onClose, idCita, onSuccess, accion, Id }) => {
  const tipo = "Centro Camionero";
  const modoSoloLectura = (accion === 'ver' || accion === 'completar');


  const [folio, setFolio] = useState(0);
  const [sucursal] = useState("SUC. NORTE");

  const [cliente, setCliente] = useState({});
  const [camion, setCamion] = useState({
    vehiculo: "", modelo: "", color: "", placas: "", unidad: "",
    llantasTipo: "", llantasMedida: 0, rinesTipo: "", rinesMedida: 0,
    amortDelantes: 0, amortTraseros: 0, kilometraje:0
  });

  const [recepcion, setRecepcion] = useState(dayjs());
  const [entrega, setEntrega] = useState(dayjs());
  const [observacion, setObservacion] = useState('');
  const [condicion, setCondicion] = useState('');
  const [factura, setFactura] = useState('');
  const [autoriSalida, setAutoriSalida] = useState('');
  const [jefeServicio, setJefeServicio] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [modo, setModo] = useState(accion);

  const [servicios, setServicios] = useState({
    diagnostico: false, alineacionDelantera: false, alineacionTrasera: false,
    correccionEje: false, correccionCaster: false, correccionCamber: false,
    balanceo: false, suspension: false, rotacion: false, plomos: 0,
    montaje: false, ponchada: false, valvulas: false, lainas: 0, cuna: 0,
    vitalizadas: 0, refacciones: '',
  });

  const handleServicioChange = (key) => (e) => {
    setServicios({ ...servicios, [key]: e.target.checked });
  };

  const handleInputChange = (field) => (e) => {
    setCamion({ ...camion, [field]: e.target.value });
  };

  const handleServicioInputChange = (key) => (e) => {
    setServicios({ ...servicios, [key]: e.target.value });
  };

  const handleSubmit = () => {
    setModo(accion);
    if (accion === 'completar' ){
      setModo('actualizar')
    } else {
      setModo('crear')
    }
    const payload = {
      folio, idCita, sucursal, cliente, camion,
      recepcion: recepcion.toISOString(), entrega: entrega.toISOString(),
      servicios, observacion, condicion, factura, jefeServicio,
      autoriSalida, tipo, modo
    };

    fetch('https://bibliotecadlago.com/php/Backend/guardarDetalleCitaCC.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        showNotification('✅ Cita registrada correctamente.', 'success');
        setTimeout(() => {
          onSuccess?.(); 
          onClose();
        }, 3000); 
      })
      .catch(error => {
        console.log(error);
        showNotification('❌ ' + error, 'error');
      });
  };

  const showNotification = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  useEffect(() => {
    if (open) {
      if (accion ==='crear') {
        fetch('https://bibliotecadlago.com/php/Backend/obtenerFolio.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        })
          .then(res => res.json())
          .then(data => setFolio(data[0]?.ultimo_id + 1));
      } else{
        setFolio(Id)
      }

      fetch('https://bibliotecadlago.com/php/Backend/infoUsuario.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ IdCita: idCita }),
      })
        .then(res => res.json())
        .then(data => {
          const clienteData = {
            facturar: data[0]?.Empresa || "",
            rfc: data[0]?.rfc || "",
            domicilio: data[0]?.Domicilio || "",
            ciudad: data[0]?.Ciudad || "",
            solicitado: data[0]?.Solicitado || "",
          };
          setCliente(clienteData);
        });

      if ((accion === 'ver' || accion === 'completar') && Id) {
        fetch('https://bibliotecadlago.com/php/Backend/obtener_OrdenServicios.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ Id }),
        })
          .then(res => res.json())
          .then(data => {
            const orden = data[0];
            setCamion({
              vehiculo: orden.Vehiculo,
              modelo: orden.Modelo,
              color: orden.Color,
              placas: orden.Placas,
              unidad: orden.Unidad,
              kilometraje: orden.Kilometraje,
              llantasTipo: orden.LlantasTipo,
              llantasMedida: orden.LlantasMedida,
              rinesTipo: orden.RinesTipo,
              rinesMedida: orden.RinesMedida,
              amortDelantes: orden.AmortDelantes,
              amortTraseros: orden.AmortTraseros,
            });

            setRecepcion(dayjs(orden.FechaRecepcion));
            setEntrega(dayjs(orden.FechaEntrega));
            setObservacion(orden.Observaciones || '');
            setCondicion(orden.Condicion || '');
            setFactura(orden.Factura || '');
            setAutoriSalida(orden.AutorizacionSalida || '');
            setJefeServicio(orden.JefeServicio || '');

            setServicios({
              diagnostico: orden.Diagnostico === 1,
              alineacionDelantera: orden.AlineacionDelantera === 1,
              alineacionTrasera: orden.AlineacionTrasera2Ejes === 1,
              correccionEje: orden.CorreccionEje === 1,
              correccionCaster: orden.CorreccionCaster === 1,
              correccionCamber: orden.CorreccionCamber === 1,
              balanceo: orden.Balanceo === 1,
              suspension: orden.Suspension === 1,
              rotacion: orden.Rotacion === 1,
              plomos: orden.Plomos === 1,
              montaje: orden.Montajes === 1,
              ponchada: orden.Ponchada === 1,
              valvulas: orden.Valvulas === 1,
              lainas: orden.Lainas,
              cuna: orden.Cuna,
              vitalizadas: orden.Vitalizadas,
              refacciones: orden.Refacciones,
            });
          });
      }
    }
  }, [open, idCita, accion, Id]);


  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onClose();
          }
        }}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle>
          Orden de Servicio - Centro Camionero
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {/* Encabezado */}
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={8}>
              <Typography variant="h6" fontWeight={800}>CENTRO CAMIONERO</Typography>
              <Typography variant="body2" color="text.secondary">
                Blvd. a Zacatecas No. 111, Las Hadas Tel. 996 87 13 — Aguascalientes, Ags.
              </Typography>
              <Stack direction="row" spacing={2} mt={1}>
                <Box component="img" src={logo} alt="Logo" sx={{ height: 35, width: 180 }} />
                <Box component="img" src={imgBri} alt="Bridgestone" sx={{ height: 38, width: 110 }} />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Box sx={{ border: "2px solid", p: 1.5, textAlign: "center", borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight={700}>ORDEN DE SERVICIO</Typography>
                <Typography variant="h4" fontWeight={900}>{folio}</Typography>
              </Box>
            </Grid>
          </Grid>
          {/* Datos del Cliente */}
          <Divider sx={{ my: 2, width: "100%" }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>DATOS DEL CLIENTE</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}><Typography><strong>FACTURAR:</strong> {cliente.facturar}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>Solicitado por:</strong> {cliente.solicitado}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>RFC:</strong> {cliente.rfc}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>DOMICILIO:</strong> {cliente.domicilio}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography><strong>CIUDAD:</strong> {cliente.ciudad}</Typography></Grid>
          </Grid>

          {/* Datos del vehículo */}
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>DATOS DEL VEHÍCULO</Typography>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 2,
                alignItems: "flex-start",
              }}
            >
              <Box
                component="img"
                src={imgCamion}
                alt="Camión"
                sx={{
                  width: { xs: "100%", md: 250 },
                  height: "auto",
                  borderRadius: 2,
                  objectFit: "cover",
                  flexShrink: 0,
                }}
              />

              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField disabled={modoSoloLectura} label="Vehículo" fullWidth size="small" value={camion.vehiculo} onChange={handleInputChange("vehiculo")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField disabled={modoSoloLectura} label="Modelo" fullWidth size="small" value={camion.modelo} onChange={handleInputChange("modelo")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField disabled={modoSoloLectura} label="Color" fullWidth size="small" value={camion.color} onChange={handleInputChange("color")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField disabled={modoSoloLectura} label="Placas" fullWidth size="small" value={camion.placas} onChange={handleInputChange("placas")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField disabled={modoSoloLectura} label="Unidad No." fullWidth size="small" value={camion.unidad} onChange={handleInputChange("unidad")} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField disabled={modoSoloLectura} label="Kilometraje" fullWidth size="small" value={camion.kilometraje} onChange={handleInputChange("kilometraje")} />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={3}>
                    <DateTimePicker disabled={modoSoloLectura} label="Recepión" value={recepcion} onChange={(val) => setRecepcion(val)} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <DateTimePicker disabled={modoSoloLectura} label="Entrega" value={entrega} onChange={(val) => setEntrega(val)} />
                  </Grid>
                  <Grid item xs={7}>
                    <TextField disabled={modoSoloLectura} fullWidth label="Tipo de llantas" variant="outlined" size="small" value={camion.llantasTipo} onChange={handleInputChange("llantasTipo")} />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField disabled={modoSoloLectura} fullWidth label="Medida" variant="outlined" size="small" value={camion.llantasMedida} onChange={handleInputChange("llantasMedida")} />
                  </Grid>
                  <Grid item xs={7}>
                    <TextField disabled={modoSoloLectura} fullWidth label="Tipo de rines" variant="outlined" size="small" value={camion.rinesTipo} onChange={handleInputChange("rinesTipo")} />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField disabled={modoSoloLectura} fullWidth label="Medida" variant="outlined" size="small" value={camion.rinesMedida} onChange={handleInputChange("rinesMedida")} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField disabled={modoSoloLectura}
                      fullWidth
                      type="number"
                      label="Amort. Delanteros No."
                      variant="outlined"
                      size="small"
                      value={camion.amortDelantes ?? 0} onChange={handleInputChange("amortDelantes")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField disabled={modoSoloLectura}
                      fullWidth
                      type="number"
                      label="Amort. Traseros No."
                      variant="outlined"
                      size="small"
                      value={camion.amortTraseros ?? 0} onChange={handleInputChange("amortTraseros")}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          {/* Servicios */}
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>SERVICIO GENERAL</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormGroup>
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.diagnostico} onChange={handleServicioChange("diagnostico")} />} label="Diagnóstico" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.alineacionDelantera} onChange={handleServicioChange("alineacionDelantera")} />} label="Alineación delantera" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.alineacionTrasera} onChange={handleServicioChange("alineacionTrasera")} />} label="Alineación trasera 2 ejes" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.correccionEje} onChange={handleServicioChange("correccionEje")} />} label="Corrección de eje torcido" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.correccionCaster} onChange={handleServicioChange("correccionCaster")} />} label="Corrección de caster" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.correccionCamber} onChange={handleServicioChange("correccionCamber")} />} label="Corrección de camber" />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormGroup>
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.balanceo} onChange={handleServicioChange("balanceo")} />} label="Balanceo" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.suspension} onChange={handleServicioChange("suspension")} />} label="Suspensión" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.rotacion} onChange={handleServicioChange("rotacion")} />} label="Rotación" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.montaje} onChange={handleServicioChange("montaje")} />} label="Montaje" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.ponchada} onChange={handleServicioChange("ponchada")} />} label="Ponchada" />
                <FormControlLabel control={<Checkbox disabled={modoSoloLectura} checked={servicios.valvulas} onChange={handleServicioChange("valvulas")} />} label="Válvulas" />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Stack spacing={2}>
                <TextField disabled={modoSoloLectura} label="Refacciones" multiline minRows={4} fullWidth value={servicios.refacciones} onChange={handleServicioInputChange("refacciones")} />
                <TextField disabled={modoSoloLectura} label="Lainas" type="number" fullWidth value={servicios.lainas ?? 0} onChange={handleServicioInputChange("lainas")} />
                <TextField disabled={modoSoloLectura} label="Plomos" type="number" fullWidth value={servicios.plomos ?? 0} onChange={handleServicioInputChange("plomos")} />
                <TextField disabled={modoSoloLectura} label="Cuña" type="number" fullWidth value={servicios.cuna ?? 0} onChange={handleServicioInputChange("cuna")} />
                <TextField disabled={modoSoloLectura} label="Vitalizadas" type="number" fullWidth value={servicios.vitalizadas ?? 0} onChange={handleServicioInputChange("vitalizadas")} />
              </Stack>
            </Grid>
          </Grid>

          {/* Observaciones */}
          <Divider sx={{ my: 2 }} />
          <TextField disabled={modoSoloLectura} fullWidth label="OBSERVACIONES" multiline minRows={3} variant="outlined" value={observacion} onChange={(event) => setObservacion(event.target.value)} />

          {/* Condiciones a la derecha */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <Box sx={{ textAlign: "right" }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                Condiciones
              </Typography>
              <FormGroup row sx={{ justifyContent: "flex-end" }}>
                {["Contado", "Crédito"].map((label) => (
                  <FormControlLabel
                    key={label}
                    control={
                      <Checkbox disabled={ accion !== 'completar'}
                        checked={condicion === label}
                        onChange={() => setCondicion(label)}
                      />
                    }
                    label={label}
                  />
                ))}
              </FormGroup>

            </Box>
          </Box>

          {/* Firmas centradas */}
          <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6}>
              <TextField disabled={ accion !== 'completar'} fullWidth label="Atendido con facturas Nos" size="small" value={factura} onChange={(event) => setFactura(event.target.value)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField disabled={ accion !== 'completar'} fullWidth label="Autorización de salida" size="small" value={autoriSalida} onChange={(event) => setAutoriSalida(event.target.value)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField disabled={ accion !== 'completar'} fullWidth label="Jefe de servicio y/o ventas" size="small" value={jefeServicio} onChange={(event) => setJefeServicio(event.target.value)} />
            </Grid>
          </Grid>

        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="inherit">Cancelar</Button>
          {(accion === 'crear' || accion === 'completar') && (
            <Button onClick={handleSubmit} variant="contained" color="primary" sx={{ backgroundColor: '#db071c', color: 'white' }}>
              Guardar
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default OrdenServicioCentroCamioneroModal;
